import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon } from 'lucide-react';
export const IdScanBack = ({
  onBack,
  onNext
}) => {
  const [scanning, setScanning] = useState(true);
  const [scanned, setScanned] = useState(false);
  useEffect(() => {
    // Simulate scanning process
    if (scanning) {
      const timer = setTimeout(() => {
        setScanning(false);
        setScanned(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [scanning]);
  return <div className="flex flex-col p-6 flex-grow bg-white" data-id="element-193">
      <div className="flex items-center mb-6" data-id="element-194">
        <button onClick={onBack} className="mr-4" data-id="element-195">
          <ChevronLeftIcon size={24} data-id="element-196" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-197">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-198"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-199"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-200"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-201"></div>
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-6 text-center" data-id="element-202">
        Now scan the <span className="text-[#4040f2]" data-id="element-203">back side</span> of your
        ID
      </h1>
      <div className="flex justify-center mb-10" data-id="element-204">
        <div className="relative w-64 h-80" data-id="element-205">
          <div className="absolute inset-0 border-2 border-red-500 rounded-lg" data-id="element-206"></div>
          {scanning ? <div className="absolute inset-0 flex items-center justify-center" data-id="element-207">
              <div className="w-12 h-12 border-t-2 border-[#5c5cf5] rounded-full animate-spin" data-id="element-208"></div>
            </div> : <div className="absolute inset-0 flex items-center justify-center overflow-hidden rounded-lg" data-id="element-209">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pe2gG8ghqTrsMke1uNaU8f/Screenshot_2025-08-08_at_6.16.54_PM.png" alt="ID Back" className="w-full h-full object-cover" data-id="element-210" />
            </div>}
        </div>
      </div>
      <div className="mt-auto" data-id="element-211">
        <button className={`w-full py-3 rounded-full font-medium text-white ${scanned ? 'bg-[#4040f2]' : 'bg-gray-300'}`} onClick={onNext} disabled={!scanned} data-id="element-212">
          CONTINUE
        </button>
      </div>
    </div>;
};